// extracted by mini-css-extract-plugin
export default {"wrp":"NoData_wrp__aY4XD"};